import logoUrl from '@/assets/logo.svg'
import markUrl from '@/assets/mark.svg'
import { cn } from '@/lib/utils'

/** The RowCall logo (mark + wordmark), or the mark alone where space is tight. */
export const BrandLogo = ({ variant = 'logo', className }: { variant?: 'logo' | 'mark'; className?: string }) => (
  <img
    src={variant === 'logo' ? logoUrl : markUrl}
    alt="RowCall"
    className={cn(variant === 'logo' ? 'h-6 w-auto' : 'size-7', className)}
  />
)
